import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Truck, ShoppingCart } from "lucide-react";
import { api, rp, num, dt } from "@/lib/api";
import { PageHeader, StatusBadge, MoneyOnly } from "@/components/common";

export default function Receiving() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/receiving/pending").then((r) => setRows(r.data)); }, []);
  const list = rows || [];
  return (
    <div className="max-w-3xl">
      <PageHeader title="Penerimaan barang" sub="Buka transaksi, cek barang, foto, konfirmasi jumlah. Stok langsung masuk ledger saat diterima." />
      {rows && list.length === 0 && <div className="text-center text-sm text-slate-500 py-16 bg-white rounded-lg border" data-testid="receiving-empty">Tidak ada transaksi menunggu penerimaan.</div>}
      <div className="space-y-2.5">
        {list.map((r) => (
          <Link key={r.id} to={`/receiving/${r.type}/${r.id}`} data-testid={`receiving-item-${r.code}`} className="block bg-white border border-slate-200 rounded-lg p-4 hover:border-emerald-600 hover:shadow-md transition-[border-color,box-shadow] fade-up">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  {r.type === "purchase" ? <ShoppingCart size={15} className="text-indigo-600" /> : <Truck size={15} className="text-emerald-600" />}
                  <span className="num font-bold text-sm">{r.code}</span><StatusBadge s={r.status} />
                </div>
                <div className="text-[13px] text-slate-600 mt-1">{r.type === "purchase" ? "Pembelian dari" : "Transfer dari"} <b>{r.from}</b> → <b>{r.to}</b>{r.sender && <> · Pengirim: <b>{r.sender.name}</b></>}</div>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {r.lines.map((l, i) => <span key={i} className="text-[12px] bg-slate-100 rounded px-2 py-0.5"><span className="font-semibold num">{num(l.qty)} {l.unit}</span> {l.item_name}</span>)}
                </div>
                <div className="text-[11px] text-slate-500 mt-2"><MoneyOnly>Nilai {rp(r.value)} · </MoneyOnly>{dt(r.created_at)}</div>
              </div>
              <ChevronRight className="text-slate-400 shrink-0" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
